
import './App.css';
import {useEffect} from "react"
import { BrowserRouter , Routes , Route } from 'react-router-dom';
import ErrorPage from "./components/ErrorPage"
import Navbar from "./components/base/Navbar"
import Home from './components/Home';
import AlphaDSF from './components/AlphaDSF';
import { Analytics } from '@vercel/analytics/react';
import { SpeedInsights } from '@vercel/speed-insights/react';
import Privacy from './components/Privacy';
import Questionnaire from './components/Questionnaire';
function App() {
 


  useEffect(() => {
    // Vérifie la préférence du système pour le mode sombre
    const darkModeQuery = window.matchMedia("(prefers-color-scheme: dark)");

    // Applique la classe 'dark' au body si le mode sombre est activé
    if (darkModeQuery.matches) {
      document.documentElement.setAttribute("data-theme", "dark"); // DaisyUI
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.setAttribute("data-theme", "light");
      document.documentElement.classList.remove("dark");
    }

    // Écoute les changements de préférence du système
    darkModeQuery.addEventListener("change", (e) => {
      if (e.matches) {
        document.body.classList.add("dark");
      } else {
        document.body.classList.remove("dark");
      }
    });
  }, []);
                  
  return (
   <BrowserRouter>

        {/** Vercel Collect Analytics */}
        <Analytics />
        <SpeedInsights />

        <Navbar />
        
         <Routes>
        
          <Route path="/" element={<Home/>} />
          <Route path="/home" element={<Home/>} />
          <Route path="/alphadsf" element={<AlphaDSF/>} />
          <Route path="/privacy" element={<Privacy/>} />
          <Route path="/formation_tableau_de_bord/questionnaire" element={<Questionnaire/>} />
        
          {/**
           * <Route path="/ousmanelearning" element={<Certificat /> } >
              <Route index element={ <Certificat />  } />
              <Route path="completion" element={ <Certificat />  } />
          </Route> 
           * 
           */}
        


          <Route path="*" element={<ErrorPage />} />

        </Routes>
    </BrowserRouter>
  );
}

export default App;



